var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolanaIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_558_718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.42381 10.6853C3.53243 10.5775 3.68179 10.5146 3.8402 10.5146H18.2058C18.4683 10.5146 18.5996 10.829 18.414 11.0131L15.5762 13.8293C15.4676 13.9371 15.3182 14 15.1598 14H0.794188C0.531679 14 0.400424 13.6856 0.585991 13.5014L3.42381 10.6853Z",
    fill: "url(#paint0_linear_558_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.42381 0.170677C3.53696 0.062881 3.68632 0 3.8402 0H18.2058C18.4683 0 18.5996 0.314405 18.414 0.498556L15.5762 3.31473C15.4676 3.42252 15.3182 3.4854 15.1598 3.4854H0.794188C0.531679 3.4854 0.400424 3.171 0.585991 2.98685L3.42381 0.170677Z",
    fill: "url(#paint1_linear_558_718)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5762 5.39431C15.4676 5.28651 15.3182 5.22363 15.1598 5.22363H0.794188C0.531679 5.22363 0.400424 5.53804 0.585991 5.72219L3.42381 8.53836C3.53243 8.64615 3.68179 8.70903 3.8402 8.70903H18.2058C18.4683 8.70903 18.5996 8.39463 18.414 8.21048L15.5762 5.39431Z",
    fill: "url(#paint2_linear_558_718)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_558_718",
    x1: 16.8335,
    y1: -1.68232,
    x2: 7.01045,
    y2: 17.2773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_558_718",
    x1: 12.4862,
    y1: -3.93462,
    x2: 2.66321,
    y2: 15.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_558_718",
    x1: 14.646,
    y1: -2.81561,
    x2: 4.82299,
    y2: 16.144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_558_718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaIcon);
export default __webpack_public_path__ + "static/media/solanaIcon.98981a617df43d4fc9b9adda47b68640.svg";
export { ForwardRef as ReactComponent };